"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metrics = exports.Instrument = void 0;
var _instrumentBase = require("../../utils/instrument-base");
var _constants = require("../constants");
// import { handle } from '../../../common/event-emitter/handle'
// import { WEBSOCKET_TAG, wrapWebSocket } from '../../../common/wrap/wrap-websocket'

class Instrument extends _instrumentBase.InstrumentBase {
  static featureName = _constants.FEATURE_NAME;
  constructor(agentIdentifier, aggregator, auto = true) {
    super(agentIdentifier, aggregator, _constants.FEATURE_NAME, auto);
    // wrapWebSocket(this.ee)

    // WATCHABLE_WEB_SOCKET_EVENTS.forEach((suffix) => {
    //   this.ee.on(WEBSOCKET_TAG + suffix, (...args) => {
    //     handle('buffered-' + WEBSOCKET_TAG + suffix, [...args], undefined, this.featureName, this.ee)
    //   })
    // })

    this.importAggregator();
  }
}
exports.Instrument = Instrument;
const Metrics = exports.Metrics = Instrument;